module.exports = __webpack_public_path__ + "static/media/8.128eff97.png";